<template>
  <div class="portfolio">
    <h1 class="portfolioTitle">{{ $t("app.portfolio.title") }}</h1>
    <div class="row">
      <div
        v-for="(item, index) in projects"
        :key="index"
        :class="`col-lg-4 col-sm-6`"
      >
        <vs-card type="5" >
          <template #title>
            <h3>{{ item.name }}</h3>
          </template>
          <template #img>
            <img
              :src="require(`../assets/projects/${item.image}`)"
              :alt="item.name"
            />
          </template>
          <template #text>
            <p>
              {{ $t(item.work) }}
            </p>
          </template>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getProjects } from '../server/serverHelper';

export default {
  name: 'Home',
  data: () => ({
    projects: [],
  }),
  beforeMount() {
    const projects = getProjects();
    this.projects = projects.data;
  },
  methods: {},
};
</script>

<style scoped>
.portfolioTitle {
  font-size: 2.4rem;
  margin: 0 0 1rem 0;
}

.portfolioCol {
  width: 100%;
}

.portfolioCard {
  width: 100%;
}

</style>
